/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import app from './modules/app'

import lookup from './modules/lookup'

// Create a new store
const store = createStore({
    state: {
        drawer: false,
        image: '',
        color: '',
        sidebarBackgroundColor: '',
    },
    mutations: {
        setDrawer(state, value) {
            state.drawer = value;
        },
        toggleDrawer(state) {
            state.drawer = !state.drawer;
        },
    },
    getters: {
        drawer: state => state.drawer
    },
    modules: {
        auth,
        app,
        lookup
    },
    plugins: [
        createPersistedState({
            paths: ['auth', 'app'],
        }),
    ],
});

export default store;
